import React, { forwardRef } from "react";
import {
  Editor as ToastEditor,
  EditorProps as ToastEditorProps,
} from "@toast-ui/react-editor";
import colorSyntax from "@toast-ui/editor-plugin-color-syntax";

import "@toast-ui/editor/toastui-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
import "@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css";
import styled from "styled-components";

const toolbarItems = [
  ["heading", "bold", "italic", "strike"],
  ["hr", "quote"],
  ["ul", "ol", "task", "indent", "outdent"],
  ["table", "link"],
  ["code", "codeblock"],
  ["scrollSync"],
];
const plugins = [colorSyntax];

interface EditorProps extends ToastEditorProps {
  height?: string;
  defaultValue?: string;
  placeholder?: string;
  errorMessage?: string;
}

const Editor = forwardRef<ToastEditor, EditorProps>(
  (
    { height = "37rem", defaultValue, placeholder, errorMessage, ...rest },
    ref,
  ) => {
    return (
      <ToastEditorWrapStyle error={!!errorMessage}>
        <ToastEditor
          {...rest}
          ref={ref}
          previewStyle="vertical"
          placeholder={placeholder}
          initialValue={defaultValue}
          initialEditType="wysiwyg"
          height={height}
          useCommandShortcut={false}
          toolbarItems={toolbarItems}
          plugins={plugins}
          hideModeSwitch
          autofocus={false}
        />

        {errorMessage && <label>{errorMessage}</label>}
      </ToastEditorWrapStyle>
    );
  },
);
Editor.displayName = "Editor";

export default Editor;

const EDITOR_BORDER_RADIUS = "0.5rem";

const ToastEditorWrapStyle = styled.div<{ error: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  label {
    padding-left: 1.6rem;
    ${({ theme }) => theme.typography.body3.regular};
    color: ${({ theme }) => theme.color.text.danger};
  }

  .toastui-editor-defaultUI {
    border: none;

    ${({ theme, error }) =>
      error && `border: 0.1rem solid ${theme.color.text.danger}`};
  }

  .toastui-editor-toolbar {
    height: unset;
    border: 0.1rem solid ${({ theme }) => theme.color.stroke.light};
    border-top-left-radius: ${EDITOR_BORDER_RADIUS};
    border-top-right-radius: ${EDITOR_BORDER_RADIUS};
  }
  .toastui-editor-defaultUI-toolbar {
    border-bottom: none;
  }

  .toastui-editor-main {
    overflow: hidden;
    border-bottom-left-radius: ${EDITOR_BORDER_RADIUS};
    border-bottom-right-radius: ${EDITOR_BORDER_RADIUS};
  }

  .toastui-editor-ww-container {
    background-color: ${({ theme }) => theme.color.background.dark};
  }
`;
